import { Link } from 'react-router-dom'
import { useState } from "react";

export default function ProdunitVideo() {

  const [isVideoLoaded, setIsVideoLoaded] = useState(false);

  const handleVideoToggle = (e) => {
    e.preventDefault();
    setIsVideoLoaded(true);
  };

  return (
    <>
    <section className="produnit-video">
        <div className="container">
            <div className="row align-items-center">  

                <div className="col-lg-7 col-md-7 order-2 order-lg-1 order-md-1">
                    <div className="prodvideo-box">
                        <div className="thumbnail-wrapper" style={{ display: isVideoLoaded ? "none" : "block",}}>
                            <img src="/image/prodvideo-thumb.webp" className="img-responsive" alt="Video thumbnail" loading="lazy"/>
                            <Link className="video-play-button" onClick={handleVideoToggle}><span></span></Link>
                        </div>

                        <div className="video-wrapper" style={{ display: isVideoLoaded ? "block" : "none",}}>
                          {isVideoLoaded && (
                            <iframe
                            width="100%"
                            height="100%"
                            src="https://www.youtube-nocookie.com/embed/HrBRj_YnKBg?autoplay=1&rel=0&modestbranding=1"
                            title="Saysha production unit video"
                            frameBorder="0"
                            allow="autoplay; encrypted-media; picture-in-picture"
                            allowFullScreen
                            ></iframe>
                          )}
                        </div>
                    </div> 
                </div>

                <div className="col-lg-5 col-md-5 order-1 order-lg-2 order-md-2">
                    <div className="prodvideo-text">
                        <p>Step into Saysha’s production unit, where craftsmanship and technology work in perfect harmony. From pressing and cutting to assembling and final inspection, every stage reflects precision, passion, and a commitment to excellence transforming raw materials into refined modular and millwork masterpieces.</p>
                    </div>
                </div>

            </div>
        </div>
    </section>
    </>
  )
}
